export default "__VITE_ASSET__0bd4b670__"